import { render, staticRenderFns } from "./ai_button_file_data.vue?vue&type=template&id=c222f60c&scoped=true"
import script from "./ai_button_file_data.vue?vue&type=script&lang=js"
export * from "./ai_button_file_data.vue?vue&type=script&lang=js"
import style0 from "./ai_button_file_data.vue?vue&type=style&index=0&id=c222f60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c222f60c",
  null
  
)

export default component.exports